import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  MenuItem,
  FormControlLabel,
  TablePagination,
  Checkbox,
  RadioGroup,
  Radio,
  FormLabel,
  IconButton,
  Paper,
  ListItemText,
  Breadcrumbs,
  Link,
  Backdrop,
  Alert,
  CircularProgress,
  Snackbar,
  Collapse,
  Autocomplete,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";




const finacialYearsOptions = [
  { option: "01 Jan - 31 Dec", value: "01 Jan - 31 Dec" },
  { option: "01 Feb - 31 Jan", value: "01 Feb - 31 Jan" },
  { option: "01 Mar - 28 Feb", value: "01 Mar - 28 Feb" },
  { option: "01 Apr - 31 Mar", value: "01 Apr - 31 Mar" },
  { option: "01 May - 30 Apr", value: "01 May - 30 Apr" },
  { option: "01 Jun - 31 May", value: "01 Jun - 31 May" },
  { option: "01 Jul - 30 Jun", value: "01 Jul - 30 Jun" },
  { option: "01 Aug - 31 Jul", value: "01 Aug - 31 Jul" },
  { option: "01 Sep - 31 Aug", value: "01 Sep - 31 Aug" },
  { option: "01 Oct - 30 Sep", value: "01 Oct - 30 Sep" },
  { option: "01 Nov - 31 Oct", value: "01 Nov - 31 Oct" },
  { option: "01 Dec - 30 Nov", value: "01 Dec - 30 Nov" },
];

let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();
const nextYear = new Date(yy + 1, mm, dd);
if (dd < 10) dd = "0" + dd;
if (mm < 10) mm = "0" + mm;

const todayDate = yy + "-" + mm + "-" + dd;



function CloseFinancialYear( ) {

  const [state,setState]=useState({
    date:todayDate,
    
    errorStatus:{
      date:false,
      

    },
    errorFields:{
      date:"",
      
    }
  })
  
  return (
    <Box
      sx={{
        width: "100%",
        //paddingTop: "80px",
        paddingTop: "80px",
        paddingRight: "0px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          marginLeft: { xs: "20px", sm: "80px" },
          marginRight: { xs: "20px", sm: "30px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 10px",
            borderRadius: "8px",
            backgroundColor: "background.paper",
            marginBottom: "20px",
            // boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
            boxShadow:
              "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            ":hover": {
              boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            },
            transition: "all 1s ease-in-out",
          }}
        ></Box>

        <Box
          sx={{
            borderRadius: "8px",
            backgroundColor: "background.paper",
            marginBottom: "20px",
            boxShadow:
              "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            padding: { xs: "10px 0px", sm: "10px 10px" },
            borderRadius: "8px",
            ":hover": {
              boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            },
            transition: "all 1s ease-in-out",
            minHeight:"490px"
          }}
        >
         <Box sx={{display:"flex",flexDirection:"column",margin:"20px",width:"400px"}}>
          <Box sx={{flex:1}}>
           <Typography sx={{
            fontSize:"15px",
            fontWeight:"bold"
           }}>
            Financial year end date
           </Typography>
           <TextField
           size="small"
           fullWidth
           type="date"
           placeholder="Closing Date"
           value={state.date}
           onChange={(e)=>{
            setState((prev)=>({
              ...prev,
              date:e.target.value
            }))
           }}
           >
          
            
           </TextField>
          </Box>
          <Box sx={{flex:1,mt:2}}>
            <Typography sx={{fontSize:"12px",color:"input.label",fontWeight:"bold"}}>
            Note:On closing, the ledger closing balance as on the above date shall be transferred to the next accounting year
            and no changes can be made further in the closed year.
            </Typography>

          </Box>
        <Box sx={{flex:1,mt:3,display:"flex"}}>
          <Button variant="outlined">Cancel</Button>
          <Button variant="contained" sx={{ml:2}}>Confirm</Button>
        
        </Box>

         </Box>
        </Box>
      </Box>
   
     
      
    </Box>
  );
}

export default CloseFinancialYear;
